/* ============================================================
   MaterialSelector — pick material for printing
   ============================================================ */

import type { Material } from '../types';

interface MaterialSelectorProps {
  materials: Material[];
  selected: string | null;
  onSelect: (id: string) => void;
  loading: boolean;
}

export function MaterialSelector({ materials, selected, onSelect, loading }: MaterialSelectorProps) {
  return (
    <div>
      <p style={{ fontSize: 'var(--fs-overline)', color: 'var(--color-text-secondary)', marginBottom: 'var(--space-sm)' }}>
        МАТЕРИАЛ
      </p>
      {loading ? (
        <div style={{ display: 'flex', gap: 'var(--space-sm)' }}>
          {Array.from({ length: 4 }).map((_, i) => (
            <div
              key={i}
              className="skeleton"
              style={{ width: '110px', height: '56px', borderRadius: 'var(--radius-md)' }}
            />
          ))}
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 'var(--space-sm)',
          }}
        >
          {materials.map((m) => {
            const isSelected = selected === m.id;
            return (
              <button
                key={m.id}
                onClick={() => onSelect(m.id)}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  padding: '10px 16px',
                  borderRadius: 'var(--radius-md)',
                  border: '1.5px solid',
                  borderColor: isSelected ? 'var(--color-primary)' : 'var(--color-separator)',
                  background: isSelected ? 'rgba(255, 149, 0, 0.06)' : 'var(--color-surface)',
                  transition: 'all var(--transition-fast)',
                  textAlign: 'left',
                  minWidth: '110px',
                }}
              >
                <span
                  style={{
                    fontSize: 'var(--fs-body)',
                    fontWeight: isSelected ? 'var(--fw-semibold)' : 'var(--fw-medium)',
                    color: 'var(--color-text-primary)',
                  }}
                >
                  {m.name}
                </span>
                <span
                  style={{
                    fontSize: 'var(--fs-caption)',
                    color: 'var(--color-text-secondary)',
                  }}
                >
                  {m.pricePerGramRub.toFixed(2)} ₽/г
                </span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
